import VehicleFuelTracker from "./VehicleFuelTracker";

export default VehicleFuelTracker;
export { VehicleFuelTracker };
